// GonPab Store – Scripts interactivos

// Inicializar animaciones de scroll (reveal)
function initReveals() {
  const reveals = document.querySelectorAll('.mt-reveal');
  if (reveals.length === 0) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
  );

  reveals.forEach((el) => observer.observe(el));
}

// Inicialización
document.addEventListener('DOMContentLoaded', initReveals);
